import React, { useState } from "react";
import { ArrowLeft, User } from "lucide-react";
import "./DashboardRightSection.css";
import RecordingandUploading from "../dashboardRightSectionComponent/RecordingandUploading";
import UploadProgress from "../uploadAndRecording/UploadProgress";
import UploadSuccess from "../uploadAndRecording/UploadSuccess";
import TranscriptProcessing from "../uploadAndRecording/TranscriptProcessing";
import { useNavigate } from "react-router-dom";
import { useOutletContext } from "react-router-dom";
import useUserStore from "../../store/useUserStore";
import { RecordingSurgicalNote } from "../dashboardRightSectionComponent/RecordingSurgicalNote";

const DashboardRightSection = () => {
  const navigate = useNavigate();

  const {
    patientDetail,
    setPatientDetail,
    isSubmitted,
    setIsSubmitted,
    activeComponent,
    setActiveComponent,
    createNewSession,
  } = useOutletContext();
  const [errorMessage, setErrorMessage] = useState();
  const [patientId, setPatientId] = useState(null)
  const { isMobile, activePage, setActivePage,user } = useUserStore();
  const [activeTab, setActiveTab] = useState("consultation")
  const [isOpen, setIsOpen] = useState(false);

  

  const toggleDropdown = () => setIsOpen(!isOpen);

  


  const handleSubmit = async () => {
    const nameParts = patientDetail.name.trim().split(" ");

    if (nameParts.length < 2) {
      setErrorMessage("Please enter both first name and last name.");
      return;
    }
    await handleCreatePatient(patientDetail)
    setErrorMessage("");
    setIsSubmitted(true);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && patientDetail.name.trim()) {
      handleSubmit();
    }
  };

  const handleCreatePatient = async (patientDetail) => {
    const { name, visitType, gender } = patientDetail;
    const [firstName, lastName] = name.split(" ");

    const patientData = {
      first_name: firstName,
      last_name: lastName,
      visit_type: true,
      dentist_id:user.dentist_id
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/patients`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(patientData),
        }
      );

      if (response.ok) {
        const responseData = await response.json();
        setPatientId(responseData?.patient_id);
        console.log("Patient created successfully:", responseData?.patient_id, firstName + " " + lastName);
      } else {
        console.error("Failed to create patient:", response.statusText, firstName + " " + lastName);
      }
    } catch (error) {
      console.error("Error creating patient:", error, firstName + " " + lastName);
    }
  };

  const renderActiveConsultationComponent = () => {
    switch (activeComponent) {
      case "recording-uploading":
        return (
          <RecordingandUploading
            patientDetail={patientDetail}
            patientId={patientId}
            setActiveComponent={setActiveComponent}
          />
        );
      case "upload-progress":
        return <UploadProgress />;
      case "upload-success":
        return <UploadSuccess />;
      case "transcript-processing":
        return (
          <TranscriptProcessing
            createNewSession={createNewSession}
            setActiveComponent={setActiveComponent}
            setPatientId={setPatientId}
          />
        );
      default:
        return null;
    }
  };

  const renderActiveSurgicalComponent = () => {
    switch (activeComponent) {
      case "recording-uploading":
        return (
          <RecordingSurgicalNote
            patientDetail={patientDetail}
            patientId={patientId}
            setActiveComponent={setActiveComponent}
          />
        );
      case "upload-progress":
        return <UploadProgress />;
      case "upload-success":
        return <UploadSuccess />;
      case "transcript-processing":
        return (
          <TranscriptProcessing
            createNewSession={createNewSession}
            setActiveComponent={setActiveComponent}
            setPatientId={setPatientId}
          />
        );
      default:
        return null;
    }
  }

  return (
    <div
      className={`right-section ${isMobile
        ? activePage === "newSession"
          ? "right-section-mobile"
          : "right-section-hidden-mobile"
        : " "
        }`}
    >
      {/* Header Section */}
      <div className="header-section">
        <div className="arrow-wrapper">
          {isMobile && (
            <button
              className="arrow-btn"
              onClick={() => setActivePage("sidebar")}
            >
              <ArrowLeft />
            </button>
          )}
          <h1 className="page-title">Patient Details</h1>
        </div>
        <div className="input-container">
          {isSubmitted ? (
            <h2 className="patient-name">{patientDetail.name}</h2>
          ) : (
            <>
              <input
                type="text"
                value={patientDetail.name}
                onChange={(e) =>
                  setPatientDetail((prev) => {
                    return { ...prev, [e.target.name]: e.target.value };
                  })
                }
                name="name"
                onKeyPress={handleKeyPress}
                placeholder="Patient name"
                className="patient-input"
              />
              <User className="input-icon" />
              <button
                onClick={handleSubmit}
                className="submit-button"
                disabled={!patientDetail.name.trim()}
              >
                Submit
              </button>
              {errorMessage && <p className="error-message">{errorMessage}</p>}
            </>
          )}
        </div>
        
        <div className="tabs-navigation">
          <button
            className={`tab-button ${activeTab === 'consultation' ? 'active' : ''}`}
            onClick={() => setActiveTab('consultation')}
          >
            Consultation
          </button>
          <button
            className={`tab-button ${activeTab === 'surgical' ? 'active' : ''}`}
            onClick={() => setActiveTab('surgical')}
          >
            Surgical Note
          </button>
        </div>
      </div>
      <div className="active-component">
        {activeTab === 'consultation' ? (renderActiveConsultationComponent()) : (renderActiveSurgicalComponent())}
      </div>
    </div>
  );
};

export default DashboardRightSection;
